<template>
  <div class="field has-addons">
    <div class="control is-expanded">
      <input
        ref="inputRef"
        :value="modelValue"
        class="input"
        type="text"
        :placeholder="placeholder"
        :disabled="loading"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup.enter="$emit('search')"
      />
    </div>
    <div class="control">
      <BaseButton
        variant="primary"
        :outlined="!modelValue"
        :loading="loading"
        :disabled="!modelValue && !hasSearched"
        :icon="['fa', 'fa-search']"
        @mousedown.prevent
        @click="$emit('search')"
      />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'OlsSearchBar',
  props: {
    modelValue: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Search OLS...' },
    hasSearched: { type: Boolean, default: true },
  },
  emits: ['update:modelValue', 'search'],
  setup() {
    const inputRef = ref(null)
    function focus() {
      inputRef.value?.focus()
    }
    return { inputRef, focus }
  },
}
</script>
